import React from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { SxProps } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

interface ReusableAddButtonProps extends Omit<ButtonProps, 'startIcon'> {
  /** Label to display and use in aria-label (i18n ready) */
  label?: string;
  /** Called on button click */
  onClick: () => void;
  /** Optional custom icon (defaults to Add) */
  icon?: React.ReactNode;
  /** Style overrides */
  sx?: SxProps;
}

/**
 * Reusable add-new-button for any entity (invoice, etc)
 */
const ReusableAddButton: React.FC<ReusableAddButtonProps> = ({
  label,
  onClick,
  icon,
  sx,
  ...buttonProps
}) => {
  const { t: tBilling } = useTranslation('billing_config');
  const buttonLabel = label ?? tBilling('invoice.filter.new_invoice');

  return (
    <Button
      data-testid="invoice-new-invoice-button"
      variant="contained"
      onClick={onClick}
      aria-label={buttonLabel}
      startIcon={icon || <AddCircleOutlineOutlinedIcon sx={{ fontSize: 22 }} />}
      sx={{
        background: '#444',
        fontWeight: 700,
        fontSize: 18,
        textTransform: 'none',
        boxShadow: 'none',
        marginX: 2,
        '&:hover': { background: '#222' },
        ...sx,
      }}
      {...buttonProps}
    >
      {buttonLabel}
    </Button>
  );
};

export default ReusableAddButton;